import store from '@/store'
export default {
  // 成品车间检索
  className: 'shopManagement',

  fields: [
    'name',
    'parentNode'
  ],
  hooks: {
    beforeFetch ({ where }) {
      // console.log(where.workShop)
      if (store.state.user.allShopManagements === 'Yes') { } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
      console.log(where)
      // if (store.state.user.adminRole === 'workshop') {
      // where.workShop = {
      //   $in: store.state.user.shopManagements
      // }
      // }
    }
  }
}
